// @ts-ignore not yet migrated
import reduceReducers from 'ContentEditorUI/utils/reduceReducers';
import baseSettingsReducer from 'ContentEditorUI/redux/reducers/settings/baseSettingsReducer';
const reducedReducers = settingsSpecificReducer => {
  return reduceReducers(baseSettingsReducer, settingsSpecificReducer);
};
export default reducedReducers;